





































import { Component, Prop, Vue } from 'vue-property-decorator';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { EventBus } from '@/utils/EventBus';
import { safeTransferFrom as alpacaSafeTransferFrom } from '@/utils/web3';
import { safeTransferFrom as wearableSafeTransferFrom } from '@/utils/web3';
import { bgShadowMap } from '@/utils/color';

@Component({
  components: {
    AlpacaBtn,
  },
})
export default class TransferPopup extends Vue {
  public showDialog: boolean = false;
  public to: string = '';
  public item: {id: string, svg_url: string, state: number, bgColor: string} | null = null;
  public transferType: 'alpaca' | 'wearable' = 'alpaca';

  get account() {
    return this.$store.getters.getAccount;
  }

  get isEgg() {
    return this.item && this.item.state === 0;
  }

  get bgColor() {
    if (this.item) {
      return this.item.bgColor;
    }
    return '#CFFFF4';
  }

  get shadowColor() {
    if (this.item && bgShadowMap.get(this.bgColor)) {
      return bgShadowMap.get(this.bgColor);
    }
    return '#9FE7D5';
  }

  public mounted() {
    EventBus.$on('item-transfer', this.getItem);
  }

  public close() {
    this.showDialog = false;
  }

  public getItem(itemInfo: {id: string, svg_url: string, state: number, bgColor: string}, type: 'alpaca' | 'wearable') {
    if (!itemInfo) {
      this.close();
      return;
    }
    this.item = itemInfo;
    this.to = '';
    this.transferType = type;
    this.showDialog = true;
  }

  public handleTransfer() {
    if (!this.item) {
      return;
    }
    if (this.transferType === 'alpaca') {
      alpacaSafeTransferFrom(this.account, this.to, this.item.id);
    }
    if (this.transferType === 'wearable') {
      wearableSafeTransferFrom(this.account, this.to, this.item.id);
    }
  }
}
